import clsx from "clsx";
export default function TextBio() {
  return (
    <div className={textWrapper}>
      <div class="flex flex-col lg:flex-row">
        <div class="lg:w-1/2 lg:mr-10">
          <div className={name}>Violet Moon (they/them)</div>
          is a polymathic artist and working mental health professional. Their
          work explores the intersections of performance, healing, and
          storytelling—through movement, sound, visual art, and language.
          <div class="mt-4">
            They began performing at age 10 in hip-hop concerts, festivals, and
            music videos across Los Angeles and later Houston, before
            extensively training in modern, post-modern, and ballet across Texas
            and the Southern California coast. At 18, Violet launched their
            professional career as an apprentice with Revolve Dance Company and
            went on to secure a guest artist contract with ARCOS Dance Company
            and perform works by Hubbard Street Dance Chicago. They then became
            a founding member and soloist with LÉON Contemporary Dance Company,
            collaborating on several original pieces by Dorrell Martin, Mike
            Esperanza, and Mario Zambrano.
          </div>
          <div class="mt-4">
            Violet went on to complete their Master’s in Clinical Mental Health
            Counseling, returning to dance with a focus on authentic movement,
            consent, ancestral connection, and body memory. Their work is about
            creating honest, authentic spaces where people can express
            themselves and heal through movement, learning from existing wounds
            and patterns to connect bridges between present and deeper parts of
            them/ourselves.
          </div>
        </div>
        <div class="lg:w-1/2">
          A multi-time grant recipient of City of Houston’s “Let Creativity
          Happen” and MET Dance Floor Residency, they were a selected
          professional at le Centre National de la Danse (CND) in Paris and an
          international residency participant at P.A.R.T.S. in Brussels.
          <div class="mt-4">
            Violet continues to create original, multi-medium work while
            facilitating wellness workshops throughout Houston that focus on
            trauma-informed care, arts accessibility, and creative
            collaboration. The goal remains to empower participants to explore
            healing through embodiment, develop personal boundaries, expand
            community reliance and resilience, and deepen relationships to Self
            and others through authenticity and innate human creativity.
          </div>
          <div class="mt-4">
            Alongside their accomplishments in international study, somatic and
            expressive arts therapy training, guest dance artist contracts, and
            a loyalty to their creative practice— Violet holds a deep reverence
            for the ever-evolving Self, remaining devoted to the dance.
          </div>
        </div>
      </div>
    </div>
  );
}

const name = clsx("font-bold lg:text-2xl text-2xl text-center lg:text-left pb-2 uppercase")
const textWrapper = clsx("text-sm text-justify lg:pt-10 lg:pb-20 pb-10");
